<template>
  <div class="home-page">
    <!-- Hero -->
    <section class="hero">
      <div class="hero-inner">
        <p class="hero-overline">探索 · 构建 · 记录</p>
        <h1 class="hero-title">深入<span class="hero-accent">技术</span>世界<br>书写思考的轨迹</h1>
        <p class="hero-desc">从前端架构到系统设计，从代码实践到工程文化。这里记录着技术探索与深度思考。</p>
        <div class="hero-search">
          <el-input
            v-model="keyword"
            placeholder="搜索文章标题、标签..."
            prefix-icon="el-icon-search"
            @keyup.enter.native="handleSearch"
            clearable
            @clear="loadArticles"
            class="search-input"
          />
        </div>
      </div>
    </section>

    <!-- 分类筛选 -->
    <div class="home-categories">
      <el-radio-group v-model="currentCategory" size="small" @change="loadArticles">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button v-for="cat in categories" :key="cat.id" :label="cat.slug">{{ cat.name }}</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 文章列表 -->
    <div class="home-articles" v-loading="loading">
      <template v-if="articles.length">
        <ArticleCard v-for="article in articles" :key="article.id" :article="article" />
      </template>
      <el-empty v-else description="暂无文章" />

      <div class="home-pagination" v-if="pagination.pages > 1">
        <el-pagination background layout="prev, pager, next" :total="pagination.total" :page-size="pagination.per_page" :current-page.sync="pagination.page" @current-change="loadArticles" />
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCard from '../../components/ArticleCard.vue'
import { frontApi } from '../../utils/api'

export default {
  name: 'Home',
  components: { ArticleCard },
  data() { return { articles: [], loading: false, keyword: '', currentCategory: '', pagination: { page: 1, per_page: 10, total: 0, pages: 0 } } },
  computed: { categories() { return this.$store.state.categories } },
  created() { this.loadArticles() },
  methods: {
    async loadArticles() {
      this.loading = true
      const params = { page: this.pagination.page, per_page: this.pagination.per_page }
      if (this.currentCategory) params.category = this.currentCategory
      if (this.keyword) params.keyword = this.keyword
      try {
        const res = await frontApi.getArticles(params)
        this.articles = res.articles || []
        this.pagination = res.pagination || { page: 1, total: 0, pages: 0 }
      } catch (e) { console.error(e) }
      this.loading = false
    },
    handleSearch() { this.pagination.page = 1; this.loadArticles() }
  }
}
</script>

<style scoped>
.hero {
  padding: 5rem 0 3rem;
  text-align: center;
}
.hero-inner { max-width: 56rem; margin: 0 auto; padding: 0 1.5rem; }
.hero-overline {
  font-family: var(--font-mono);
  font-size: 0.75rem;
  color: var(--blog-accent);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 1rem;
}
.hero-title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 5vw, 2.75rem);
  font-weight: 700;
  line-height: 1.15;
  color: var(--blog-text);
  letter-spacing: -0.03em;
  margin-bottom: 1.25rem;
}
.hero-accent { color: var(--blog-accent); }
.hero-desc {
  font-size: 1.1rem;
  color: var(--blog-text-2);
  line-height: 1.7;
  max-width: 45ch;
  margin: 0 auto 2rem;
}
.search-input { max-width: 24rem; margin: 0 auto; }

.home-categories {
  display: flex;
  justify-content: center;
  padding: 1.5rem 0;
}
.home-articles { max-width: 42rem; margin: 0 auto; padding: 0 1.5rem; }
.home-pagination { display: flex; justify-content: center; margin-top: 2rem; padding-bottom: 3rem; }
</style>
